// import styled from 'styled-components'

import { FlexContainer } from '../../styles/defaults'
import { maxmedia } from '../../styles/media-queries'
import { Container as SearchInputContainer } from '../../components/SearchInput/styles'

export const FilterContainer = FlexContainer.extend`
  ${SearchInputContainer} {
    ${maxmedia.large`
      width: calc(50% - 1.5rem);
    `} ${maxmedia.medium`
      width: 100%;
    `};
  }
`



// WEBPACK FOOTER //
// ./src/views/Assortiment/styles.js